import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAddNewUserMutation } from './usersApiSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { ROLES } from '../../config/roles';
import useTitle from '../../hooks/useTitle';

const USER_REGEX = /^[A-z]{3,20}$/;
const PWD_REGEX = /^[A-z0-9!@#$%]{4,12}$/;

const NewUserForm = () => {
  useTitle('Dan D. Repairs | New User');
  const [addNewUser, { isLoading, isSuccess, isError, error }] =
    useAddNewUserMutation();

  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [validUsername, setValidUsername] = useState(false);
  const [password, setPassword] = useState('');
  const [validPassword, setValidPassword] = useState(false);
  const [roles, setRoles] = useState(['Employee']);

  useEffect(() => {
    setValidUsername(USER_REGEX.test(username));
  }, [username]);

  useEffect(() => {
    setValidPassword(PWD_REGEX.test(password));
  }, [password]);

  useEffect(() => {
    if (isSuccess) {
      setUsername('');
      setPassword('');
      setRoles([]);
      navigate('/dash/users');
    }
  }, [isSuccess, navigate]);

  const onUsernameChanged = (e) => setUsername(e.target.value);
  const onPasswordChanged = (e) => setPassword(e.target.value);

  const onRolesChanged = (e) => {
    const values = Array.from(
      e.target.selectedOptions, //HTML Collection
      (option) => option.value
    );
    setRoles(values);
  };

  const canSave =
    [roles.length, validUsername, validPassword].every(Boolean) && !isLoading;

  const onSaveUserClicked = async (e) => {
    e.preventDefault();
    if (canSave) {
      await addNewUser({ username, password, roles });
    }
  };

  const options = Object.values(ROLES).map((role) => {
    return (
      <option key={role} value={role}>
        {role}
      </option>
    );
  });

  const errClass = isError ? 'errmsg' : 'offscreen';
  const validUserClass = !validUsername ? 'form__input--incomplete' : '';
  const validPwdClass = !validPassword ? 'form__input--incomplete' : '';
  const validRolesClass = !Boolean(roles.length)
    ? 'form__input--incomplete'
    : '';

  const content = (
    <>
      <p className={errClass}>{error?.data?.message}</p>

      <form onSubmit={onSaveUserClicked} className='form'>
        <div className='form__title-row'>
          <h2>New User</h2>
          <div className='form__action-buttons'>
            <button className='icon-button' title='Save' disabled={!canSave}>
              <FontAwesomeIcon icon={faSave} />
            </button>
          </div>
        </div>
        <label htmlFor='username' className='form__label'>
          Username <span className='nowrap'>[3-20 letters]</span>
        </label>
        <input
          type='text'
          className={`form__input ${validUserClass}`}
          id='username'
          name='username'
          autoComplete='off'
          value={username}
          onChange={onUsernameChanged}
        />
        <label htmlFor='password' className='form__label'>
          Password <span className='nowrap'>[4-12 chars incl. !@#$%]</span>
        </label>
        <input
          type='password'
          className={`form__input ${validPwdClass}`}
          id='password'
          name='password'
          value={password}
          onChange={onPasswordChanged}
        />
        <label htmlFor='roles' className='form__label'>
          ASSIGNED ROLES:
        </label>
        <select
          className={`form__input ${validRolesClass}`}
          id='roles'
          name='roles'
          value={roles}
          onChange={onRolesChanged}
          multiple={true}
          size='3'
        >
          {options}
        </select>
      </form>
    </>
  );

  return content;
};

export default NewUserForm;
